import React, { FC } from 'react'
import moment from 'moment'
import { InformationCircleIcon } from '@heroicons/react/solid'
import { StyledPaymentPlanSelect } from '.'
import { LabelWrapper, Radio } from '../../System'
import { courseFirstTimePrice, coursePrice } from '../../utils/stripePrices'
import { ToolTipWrapper } from '../../ToolTip'

type Props = {
  courseId: string;
  onChange: (e: any) => void;
}

const PaymentPlanSelect: FC<Props> = ({ courseId, onChange }) => {
  return (
    <StyledPaymentPlanSelect className="payment-plan-select">
      <LabelWrapper label="Choose a payment plan">
        <Radio
          label="One Payment of $197"
          value={coursePrice}
          name={`payment-plan-${courseId}`}
          defaultChecked
          onChange={(e) => onChange(e)}
        />
        <Radio
          label={(
            <>
              Two Payments of $115{' '}
              <ToolTipWrapper
                label={`$115 will be charged immediately and the remaining $115 will be charged in 30 days on ${moment()
                  .add(1, 'months')
                  .format('MM/DD/YY')}`}
              >
                <div>
                  <InformationCircleIcon />
                </div>
              </ToolTipWrapper>
            </>
          )}
          value={courseFirstTimePrice}
          name={`payment-plan-${courseId}`}
          onChange={(e) => onChange(e)}
        />
      </LabelWrapper>
    </StyledPaymentPlanSelect>
  )
}

export default PaymentPlanSelect
